import * as React from 'react';
import * as moment from 'moment';
import * as ReactTimeout from 'react-timeout';
import {observer} from 'mobx-react';
import {observable} from 'mobx';
import {UIState, WellnessTabs} from 'data/UIState';
import {HorizontalAds} from './ads/ads';
import {FeedItem} from './feed/FeedItem/FeedItem';
import {PageWrapper} from "components/widgets/PageWrapper";
import {MainStageData} from "data/MainStageData";
import {MainStageEventsBar} from "components/mainstage/MainStageEventsBar";
import {TrackersBar} from "components/feed/TrackersBar";
import {RewardsBar} from "components/feed/RewardsBar";
import {Notification} from "components/widgets/Notification/Notification";
import {PageEnum, PageEnums} from "components/nav/PageEnums";
import FullPostModalData from "../data/FullPostModalData";
import {modalLoader} from "./widgets/modal/ModalLoader";
import {ModalContent} from "./widgets/modal/ModalContent";



/**
 * This component pulls together all of the pieces for the Feed
 *
 */


interface Props {
	nav:any;
}

@observer
class _FeedLandingPage extends React.Component<Props> {

	@observable milestones: Array<any> = [];
	@observable contentScrollY: number = 0;

	constructor(props) {
		super(props);
	}

	openFullPostModal = (feedItem) => {
		FullPostModalData.openFeedItemInFullPostModal(feedItem);
	}

	handleContentScroll = (y: number) => {
		this.contentScrollY = y;
	}

	handleClickToGoalsPage = () => {
		UIState.wellnessTab = WellnessTabs.GOALS;
		UIState.currentPage = PageEnums.myWellness;
	}

	handleClickToRewardsPage = () => {
		UIState.currentPage = PageEnums.prizes;
	}

	openPointsOverview = () => {
		const modalContent = <ModalContent rawHTML={UIState.feedData.solution.overview} settings={UIState.settings} user={UIState.user}/>;
		modalLoader.open('Overview', modalContent);
	}

	render(){

		let header: any;
		let headerHeight = UIState.fullsizedHeader;

		let contentStyle:any = {

		}

		if(MainStageData.mainStageEventsEnabled) {
			header = <MainStageEventsBar />;
			headerHeight = 112;
		} else if (UIState.trackerBarEnabled) {
			header = <TrackersBar contentScrollY={this.contentScrollY} />;
		} else {
			contentStyle.marginTop = '132px';
			header = <RewardsBar
				openChallengeOverview={this.openPointsOverview}
				chartablePosts={UIState.feedData.chartablePosts}
				handleClickToRewardsPage={this.handleClickToRewardsPage}
				handleClickToGoalsPage={this.handleClickToGoalsPage}
				contentScrollY={this.contentScrollY}
				solution={UIState.feedData.solution}
			/>;
		}

		let alerts: any;
		if (UIState.notifications) {
			alerts = <div className="alerts">
				{UIState.notifications.map((notification, idx) => {
					return (
						<Notification
							user={UIState.user}
							key={idx}
							notification={notification}
							delay={idx}
							handleSetCurrentPage={(pageName:string)=>{
								UIState.setCurrentPageByName(pageName);
							}}
						/>
					)})}
			</div>;
		}

		const pageEnum = new PageEnum("home", "Feed");
		const feedItems = addDateHeadersToFeedItems(UIState.feedData.feed);

		return (
			<div>				
				{this.props.nav}

				<PageWrapper
					onContentScroll={this.handleContentScroll}
					contentStyle={contentStyle}
					pageEnum={pageEnum}
					header={header}
					alerts={alerts}
				>
					<div>
						<div>
							<HorizontalAds
								ads={UIState.feedData.ads}
								user={UIState.user}
								handleSetCurrentPage={(pageName:string)=>{
									UIState.setCurrentPageByName(pageName);
								}}
							/>

							<span className="stack">
								{feedItems.map(feedItem=>
									<FeedItem
										user={UIState.user}
										key={feedItem._id}
										feedItem={feedItem}
										openFullPostModal={this.openFullPostModal}
										updateFeedItem={UIState.feedData.updateFeedItemInBrowser}
									/>
								)}
							</span>

						</div>
					</div>
				</PageWrapper>
			</div>
			);
		}		
}



function addDateHeadersToFeedItems(srcFeedItems) {
	const feedItems:Array<any> = [];
	let prevDay:moment.Moment = moment('01-01-1970 12:00 PM', 'MM-DD-YYYY hh:mm A'); // moment('1/1/1970');
	let thisDay:moment.Moment;
	const today = moment().startOf('day');
	const yesterday = today.clone().subtract(1, 'days').startOf('day');
	for(let i=0,ii=srcFeedItems.length;i<ii;i++){
		thisDay = moment(srcFeedItems[i].displayDate);
		if(!thisDay.isSame(prevDay, 'day')) {
			let content = "";
			if(thisDay.isSame(today, 'd')) {
				content = "Today";
			} else {
				const diffInDays = today.diff(thisDay, 'days')
				if(thisDay.isSame(yesterday, 'd')) {
					content = "Yesterday";
				} else if(diffInDays<=6) {
					content = thisDay.format('dddd');
				} else {
					content = thisDay.format('MMM DD – dddd');
				}
			}
			feedItems.push({"_id":`${thisDay.format('x')}-${i}`,"type":"headline","content":content});
		}
		feedItems.push(srcFeedItems[i]);				
		prevDay = thisDay;
	}
	return feedItems;
}





const FeedLandingPage = ReactTimeout(_FeedLandingPage);
export { FeedLandingPage };






